const priestPassiveImageLink = 'https://static.wikia.nocookie.net/eternitywiki/images/1/1c/Priest_passive_icon.png';
const commonPassiveImageLink = 'https://static.wikia.nocookie.net/eternitywiki/images/0/0f/Generic_passive_icon.png';

let deity = {
    berath: {
        name: 'Berath',
        favoredDispositions: ['Stoic', 'Rational'],
        condemnedDispositions: ['Cruel', 'Passionate']
    },
    eothas: {
        name: 'Eothas',
        favoredDispositions: ['Honest', 'Benevolent'],
        condemnedDispositions: ['Cruel', 'Deceptive']
    },
    magran: {
        name: 'Magran',
        favoredDispositions: ['Aggressive', 'Clever'],
        condemnedDispositions: ['Passionate', 'Diplomatic']
    },
    skaen: {
        name: 'Skaen',
        favoredDispositions: ['Cruel', 'Deceptive'],
        condemnedDispositions: ['Aggressive', 'Benevolent']
    },
    wael: {
        name: 'Wael',
        favoredDispositions: ['Deceptive', 'Clever'],
        condemnedDispositions: ['Rational', 'Honest']
    }
};

export default {
    name: 'Priest',
    endurancePerLevel: 12,
    healthMultiplier: 4,
    accuracy: 20,
    deflection: 15,
    skillBonuses: {
        athletics: +1,
        lore: +2
    },
    baseAbility: {
        level: '1',
        link: 'https://pillarsofeternity.fandom.com/wiki/Holy_Radiance',
        imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/b/b7/Holy_radiance_icon.png',
        name: 'Holy Radiance',
        speed: 'Fast',
        range: '',
        area: '5.0m Radius from Caster',
        duration: '15.0 seconds',
        effects: '<ul><li>Friendly AoE: +15 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a> (base)</li><li>Foe AoE (<a href="https://pillarsofeternity.fandom.com/wiki/Vessel" class="mw-redirect" title="Vessel">Vessels</a>): 30 <a href="https://pillarsofeternity.fandom.com/wiki/Burn" title="Burn"><img alt="Burn" src="https://static.wikia.nocookie.net/eternitywiki/images/a/aa/Burn_icon.png" decoding="async" width="18" height="18" /></a> <a href="https://pillarsofeternity.fandom.com/wiki/Damage" class="mw-redirect" title="Damage">damage</a> over 3 seconds</li><li>Foe AoE (<a href="https://pillarsofeternity.fandom.com/wiki/Vessel" class="mw-redirect" title="Vessel">Vessels</a>): If successful: <a href="https://pillarsofeternity.fandom.com/wiki/Frightened" class="mw-redirect" title="Frightened">Frightened</a></li></ul>',
        description: 'Creates a field of holy energy around the priest, Burning any vessels in the vicinity and regenerating a modest amount of Endurance for allies. The power of a priest\'s Holy Radiance is modified by how well his or her Reputations align with the preferred behaviors of his or her faith.</td></tr><tr><td style="text-align:center;"><a href="/wiki/File:Armor_of_faith_icon.png" class="image"><img alt="Armor of faith icon.png" src="https://static.wikia.nocookie.net/eternitywiki/images/f/ff/Armor_of_faith_icon.png" decoding="async" width="42" height="42" /></a>',
    },
    abilities: [
        {
            level: '1',
            link: 'https://pillarsofeternity.fandom.com/wiki/Armor_of_Faith',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/f/ff/Armor_of_faith_icon.png',
            name: 'Armor of Faith',
            speed: 'Average',
            range: '5m',
            area: '2.5m Radius',
            duration: '30.0 seconds',
            effects: '<ul><li>Friendly AoE: +4 <a href="https://pillarsofeternity.fandom.com/wiki/Damage_Reduction" title="Damage Reduction (DR)"><img alt="Damage Reduction (DR)" src="https://static.wikia.nocookie.net/eternitywiki/images/2/29/Damage_reduction_icon.png" decoding="async" width="16" height="16" /></a></li></ul>',
            description: 'Creates a tangible shield of faith, increasing the Damage Reduction of allies in the area of effect.',
        },
        {
            level: '1',
            link: 'https://pillarsofeternity.fandom.com/wiki/Barbs_of_Condemnation',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/c/c8/Barbs_of_condemnation_icon.png',
            name: 'Barbs of Condemnation',
            speed: 'Average',
            range: '12m',
            area: '',
            duration: '10.0 seconds',
            effects: '<ul><li>20-30 <a href="https://pillarsofeternity.fandom.com/wiki/Pierce" title="Pierce"><img alt="Pierce" src="https://static.wikia.nocookie.net/eternitywiki/images/5/52/Pierce_icon.png" decoding="async" width="18" height="18" /></a> damage</li><li>-5 All <a href="https://pillarsofeternity.fandom.com/wiki/Defense" title="Defenses"><img alt="Defenses" src="https://static.wikia.nocookie.net/eternitywiki/images/a/af/Defenses_icon.png" decoding="async" width="16" height="16" /></a></li></ul>',
            description: 'Punishes a target for their sins, decreasing their Deflection, Fortitude, Reflex, and Will.',
        },
        {
            level: '1',
            link: 'https://pillarsofeternity.fandom.com/wiki/Blessing',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/7/75/Blessing_icon.png',
            name: 'Blessing',
            speed: 'Average',
            range: '5m',
            area: '5.0m Radius',
            duration: '20.0 seconds',
            effects: '<ul><li>Friendly AoE: +5 <a href="https://pillarsofeternity.fandom.com/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a></li><li>Friendly AoE: +10% <a href="https://pillarsofeternity.fandom.com/wiki/Damage" title="Damage"><img alt="Damage" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e2/Damage_icon.png" decoding="async" width="18" height="18" /></a></li></ul>',
            description: 'A call for divine favor that increases the Accuracy and damage of allies in the area of effect.',
        },
        {
            level: '1',
            link: 'https://pillarsofeternity.fandom.com/wiki/Divine_Terror',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/3/30/Divine_terror_icon.png',
            name: 'Divine Terror',
            speed: 'Average',
            range: '5m',
            area: '1.25m Radius',
            duration: '15.0 seconds',
            effects: '<ul><li>Foe AoE: <a href="https://pillarsofeternity.fandom.com/wiki/Frightened" class="mw-redirect" title="Frightened">Frightened</a></li></ul>',
            description: 'Strikes fear into the hearts of the unworthy, inflicting a penalty to Accuracy on all enemies in the area of effect.',
        },
        {
            level: '1',
            link: 'https://pillarsofeternity.fandom.com/wiki/Halt',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/a/a0/Halt_icon.png',
            name: 'Halt',
            speed: 'Fast',
            range: '10m',
            area: '',
            duration: '10.0 seconds',
            effects: '<ul><li>Target: <a href="https://pillarsofeternity.fandom.com/wiki/Stuck" class="mw-redirect" title="Stuck">Stuck</a></li></ul>',
            description: 'Commands a single enemy to halt, causing them to temporarily cease all movement.',
        },
        {
            level: '1',
            link: 'https://pillarsofeternity.fandom.com/wiki/Holy_Meditation',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/b/bc/Holy_meditation_icon.png',
            name: 'Holy Meditation',
            speed: 'Fast',
            range: '10m',
            area: '2.5m Radius',
            duration: '30.0 seconds',
            effects: '<ul><li>Friendly AoE: +30 <a href="https://pillarsofeternity.fandom.com/wiki/Concentration" class="mw-redirect" title="Concentration">Concentration</a></li><li>Friendly AoE: +15 <a href="https://pillarsofeternity.fandom.com/wiki/Will" class="mw-redirect" title="Will">Will</a></li></ul>',
            description: 'The priest clears his or her mind, spreading that clarity to nearby allies, thereby increasing their Concentration and Will Bonuses.',
        },
        {
            level: '1',
            link: 'https://pillarsofeternity.fandom.com/wiki/Prayer_Against_Fear',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/f/fa/Prayer_against_fear_icon.png',
            name: 'Prayer Against Fear',
            speed: 'Fast',
            range: '5m',
            area: '3.0m Radius',
            duration: '20.0 seconds',
            effects: '<ul><li>Friendly AoE: Immunity: <a href="https://pillarsofeternity.fandom.com/wiki/Frightened" class="mw-redirect" title="Frightened">Frightened</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Terrified" class="mw-redirect" title="Terrified">Terrified</a></li></ul>',
            description: 'Steels the mind of allies in the area of effect against all external fears, granting immunity to the Frightened and Terrified afflictions.',
        },
        {
            level: '1',
            link: 'https://pillarsofeternity.fandom.com/wiki/Restore_Minor_Endurance',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/f/f7/Restore_minor_endurance_icon.png',
            name: 'Restore Minor Endurance',
            speed: 'Fast',
            range: '5m',
            area: '1.5m Radius',
            duration: '',
            effects: '<ul><li>Friendly AoE: +12 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a></li></ul>',
            description: 'Shares a portion of the caster\'s divine strength, restoring some Endurance to all allies in the area of effect.',
        },
        {
            level: '1',
            link: 'https://pillarsofeternity.fandom.com/wiki/Withdraw',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/1/1a/Withdraw_icon.png',
            name: 'Withdraw',
            speed: 'Fast',
            range: '5m',
            area: '',
            duration: '20.0 seconds',
            effects: '<ul><li>Friendly Target: Invisible</li><li>Friendly Target: +76.7 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a> over time</li><li>Friendly Target: <a href="https://pillarsofeternity.fandom.com/wiki/Stasis_Shield?action=edit&amp;redlink=1" class="new" title="Stasis Shield (page does not exist)">Stasis Shield</a></li></ul>',
            description: 'Isolates a single target within a protective sphere, shielding them from harm while their Endurance regenerates.',
        },
        {
            level: '3',
            link: 'https://pillarsofeternity.fandom.com/wiki/Consecrated_Ground',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/6/64/Consecrated_ground_icon.png',
            name: 'Consecrated Ground',
            speed: 'Average',
            range: '',
            area: '2.5m Radius from Caster',
            duration: '20.0 seconds',
            effects: '<ul><li>Friendly AoE: +9.3 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a> per second</li></ul>',
            description: 'Creates a long-lasting circle of healing, regenerating ally Endurance.',
        },
        {
            level: '3',
            link: 'https://pillarsofeternity.fandom.com/wiki/Divine_Mark',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/e/e6/Divine_mark_icon.png',
            name: 'Divine Mark',
            speed: 'Average',
            range: '2.5m',
            area: '',
            duration: '10.0 seconds',
            effects: '<ul><li>40-50 <a href="https://pillarsofeternity.fandom.com/wiki/Burn" title="Burn"><img alt="Burn" src="https://static.wikia.nocookie.net/eternitywiki/images/a/aa/Burn_icon.png" decoding="async" width="18" height="18" /></a> <a href="https://pillarsofeternity.fandom.com/wiki/Damage" title="Damage"><img alt="Damage" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e2/Damage_icon.png" decoding="async" width="18" height="18" /></a></li><li>-25 <a href="https://pillarsofeternity.fandom.com/wiki/Deflection" title="Deflection"><img alt="Deflection" src="https://static.wikia.nocookie.net/eternitywiki/images/3/3e/Deflection_icon.png" decoding="async" width="18" height="18" /></a></li></ul>',
            description: 'Marks a target for retribution, inflicting Burn damage and lowering Deflection.',
        },
        {
            level: '3',
            link: 'https://pillarsofeternity.fandom.com/wiki/Holy_Power',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/f/ff/Holy_power_icon.png',
            name: 'Holy Power',
            speed: 'Average',
            range: '',
            area: 'Aura Range: 1.3m',
            duration: '30.0 seconds',
            effects: '<ul><li>Friendly Aura: +3 <a href="https://pillarsofeternity.fandom.com/wiki/Might" title="Might">Might</a></li><li>Friendly Aura: +7 <a href="https://pillarsofeternity.fandom.com/wiki/Resolve" title="Resolve">Resolve</a></li></ul>',
            description: 'Creates a zone of divine favor, increasing the Might and Resolve of allies in the area of effect.',
        },
        {
            level: '3',
            link: 'https://pillarsofeternity.fandom.com/wiki/Iconic_Projection',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/9/9a/Iconic_projection_icon.png',
            name: 'Iconic Projection',
            speed: 'Fast',
            range: '',
            area: 'Length: 10m',
            duration: '',
            effects: '<ul><li>Foe Target: 20 <a href="https://pillarsofeternity.fandom.com/wiki/Freeze" title="Freeze"><img alt="Freeze" src="https://static.wikia.nocookie.net/eternitywiki/images/9/95/Freeze_icon.png" decoding="async" width="18" height="18" /></a> damage</li><li>Friendly Target: +20 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a></li></ul>',
            description: 'Creates a slow-moving energetic projection of the priest\'s faith, returning Endurance to allies and inflicting Freeze damage to enemies.',
        },
        {
            level: '3',
            link: 'https://pillarsofeternity.fandom.com/wiki/Instill_Doubt',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/c/c0/Instill_doubt_icon.png',
            name: 'Instill Doubt',
            speed: 'Average',
            range: '5m',
            area: '1.75m Radius',
            duration: '20.0 seconds',
            effects: '<ul><li>Foe AoE: <a href="https://pillarsofeternity.fandom.com/wiki/Dazed" class="mw-redirect" title="Dazed">Dazed</a></li></ul>',
            description: 'Taps into subconscious uncertainties, reducing the Speed of all enemies in the area of effect.',
        },
        {
            level: '3',
            link: 'https://pillarsofeternity.fandom.com/wiki/Prayer_Against_Infirmity',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/7/79/Prayer_against_infirmity_icon.png',
            name: 'Prayer Against Infirmity',
            speed: 'Fast',
            range: '5m',
            area: '3.0m Radius',
            duration: '20.0 seconds',
            effects: '<ul><li>Friendly AoE: Immunity: <a href="https://pillarsofeternity.fandom.com/wiki/Sickened" class="mw-redirect" title="Sickened">Sickened</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Weakened" class="mw-redirect" title="Weakened">Weakened</a></li></ul>',
            description: 'Fortifies the health of allies in the area of effect, granting immunity to the Sickened and Weakened afflictions.',
        },
        {
            level: '3',
            link: 'https://pillarsofeternity.fandom.com/wiki/Repulsing_Seal',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/6/66/Repulsing_seal_icon.png',
            name: 'Repulsing Seal',
            speed: 'Average',
            range: '5m',
            area: '1.25m Radius Hazard',
            duration: '600.0 seconds',
            effects: '<ul><li>Hazard AoE: <a href="https://pillarsofeternity.fandom.com/wiki/Prone" class="mw-redirect" title="Prone">Prone</a> for 7 seconds</li></ul>',
            description: 'Places a magical seal on the floor that sends enemies sprawling on contact, causing them to become Prone.',
        },
        {
            level: '3',
            link: 'https://pillarsofeternity.fandom.com/wiki/Restore_Light_Endurance',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/e/e6/Restore_light_endurance_icon.png',
            name: 'Restore Light Endurance',
            speed: 'Fast',
            range: '5m',
            area: '1.5m Radius',
            duration: '',
            effects: '<ul><li>Friendly AoE: +18 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a></li></ul>',
            description: 'Shares a portion of the caster\'s divine strength, restoring some Endurance to all allies in the area of effect.',
        },
        {
            level: '3',
            link: 'https://pillarsofeternity.fandom.com/wiki/Suppress_Affliction',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/f/f9/Suppress_affliction_icon.png',
            name: 'Suppress Affliction',
            speed: 'Average',
            range: '5m',
            area: '1.75m Radius',
            duration: '5.0 seconds',
            effects: '<ul><li>Friendly AoE: Hostile effects suspended</li></ul>',
            description: 'Stifles detrimental conditions through sheer force of will, temporarily suspending hostile status effects on allies in the area of effect.',
        },
        {
            level: '5',
            link: 'https://pillarsofeternity.fandom.com/wiki/Circle_of_Protection',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/c/cf/Circle_of_protection_icon.png',
            name: 'Circle of Protection',
            speed: 'Average',
            range: '10m',
            area: '5.0m Radius',
            duration: '10.0 seconds',
            effects: '<ul><li>Friendly AoE: +15 All <a href="https://pillarsofeternity.fandom.com/wiki/Defense" title="Defenses"><img alt="Defenses" src="https://static.wikia.nocookie.net/eternitywiki/images/a/af/Defenses_icon.png" decoding="async" width="16" height="16" /></a></li></ul>',
            description: 'Creates a large zone of divine shelter, granting allies a bonus to all Defenses.',
        },
        {
            level: '5',
            link: 'https://pillarsofeternity.fandom.com/wiki/Despondent_Blows',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/3/3f/Despondent_blows_icon.png',
            name: 'Despondent Blows',
            speed: 'Average',
            range: '10m',
            area: '1.25m Radius',
            duration: '30.0 seconds',
            effects: '<ul><li>Foe AoE: -15 Melee <a href="https://pillarsofeternity.fandom.com/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a></li><li>Foe AoE: +15% of <a href="https://pillarsofeternity.fandom.com/wiki/Crit" class="mw-redirect" title="Crit">Crits</a> converted to <a href="https://pillarsofeternity.fandom.com/wiki/Hit" class="mw-redirect" title="Hit">Hits</a></li></ul>',
            description: 'Nagging doubt in the face of unbreakable faith consumes enemies in the area of effect, lowering their Melee Accuracy and Critical Hit range.',
        },
        {
            level: '5',
            link: 'https://pillarsofeternity.fandom.com/wiki/Dire_Blessing',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/f/f6/Dire_blessing_icon.png',
            name: 'Dire Blessing',
            speed: 'Fast',
            range: '5m',
            area: '2.5m Radius',
            duration: '30.0 seconds',
            effects: '<ul><li>Friendly AoE: +20% of <a href="https://pillarsofeternity.fandom.com/wiki/Hit" class="mw-redirect" title="Hit">Hits</a> converted to <a href="https://pillarsofeternity.fandom.com/wiki/Crit" class="mw-redirect" title="Crit">Crits</a></li></ul>',
            description: 'Strengthens allies\' resolve in battle, increasing the probability they will land a Critical Hit.',
        },
        {
            level: '5',
            link: 'https://pillarsofeternity.fandom.com/wiki/Pillar_of_Faith',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/0/02/Pillar_of_faith_icon.png',
            name: 'Pillar of Faith',
            speed: 'Average',
            range: '10m',
            area: 'Target + 1.25m Radius',
            duration: '10.0 seconds',
            effects: '<ul><li>Target: 30-40 <a href="https://pillarsofeternity.fandom.com/wiki/Crush" title="Crush"><img alt="Crush" src="https://static.wikia.nocookie.net/eternitywiki/images/8/8f/Crush_icon.png" decoding="async" width="18" height="18" /></a>&#160;<a href="https://pillarsofeternity.fandom.com/wiki/Damage" title="Damage"><img alt="Damage" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e2/Damage_icon.png" decoding="async" width="18" height="18" /></a> (+10 <a href="https://pillarsofeternity.fandom.com/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a> vs <a href="https://pillarsofeternity.fandom.com/wiki/Reflex" title="Reflex"><img alt="Reflex" src="https://static.wikia.nocookie.net/eternitywiki/images/8/80/Reflex_icon.png" decoding="async" width="18" height="18" /></a>)</li><li>Foe AoE: <a href="https://pillarsofeternity.fandom.com/wiki/Prone" class="mw-redirect" title="Prone">Prone</a> (+15 <a href="https://pillarsofeternity.fandom.com/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a> vs <a href="https://pillarsofeternity.fandom.com/wiki/Fortitude" title="Fortitude"><img alt="Fortitude" src="https://static.wikia.nocookie.net/eternitywiki/images/b/b9/Fortitude_icon.png" decoding="async" width="18" height="18" /></a>)</li></ul>',
            description: 'Calls down a pillar of divine judgment, inflicting Crush damage and Knockdown on enemies in the area of effect.',
        },
        {
            level: '5',
            link: 'https://pillarsofeternity.fandom.com/wiki/Prayer_Against_Restraint',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/7/7a/Prayer_against_restraint_icon.png',
            name: 'Prayer Against Restraint',
            speed: 'Fast',
            range: '5m',
            area: '3.0m Radius',
            duration: '20.0 seconds',
            effects: '<ul><li>Friendly AoE: Immunity: <a href="https://pillarsofeternity.fandom.com/wiki/Hobbled" class="mw-redirect" title="Hobbled">Hobbled</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Stuck" class="mw-redirect" title="Stuck">Stuck</a></li></ul>',
            description: 'Frees allies in the area of effect from perceived constraints, granting immunity to the Hobbled and Stuck afflictions.',
        },
        {
            level: '5',
            link: 'https://pillarsofeternity.fandom.com/wiki/Restore_Moderate_Endurance',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/9/9e/Restore_moderate_endurance_icon.png',
            name: 'Restore Moderate Endurance',
            speed: 'Fast',
            range: '5m',
            area: '1.5m Radius',
            duration: '',
            effects: '<ul><li>Friendly AoE: +26 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a></li></ul>',
            description: 'Shares a portion of the caster\'s divine strength, restoring a moderate amount of Endurance to all allies in the area of effect.',
        },
        {
            level: '5',
            link: 'https://pillarsofeternity.fandom.com/wiki/Warding_Seal',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/8/85/Warding_seal_icon.png',
            name: 'Warding Seal',
            speed: 'Average',
            range: '10m',
            area: '1.25m Radius Hazard',
            duration: '600.0 seconds',
            effects: '<ul><li>Hazard AoE: 40-50 <a href="https://pillarsofeternity.fandom.com/wiki/Shock" title="Shock"><img alt="Shock" src="https://static.wikia.nocookie.net/eternitywiki/images/8/89/Shock_icon.png" decoding="async" width="18" height="18" /></a>&#160;<a href="https://pillarsofeternity.fandom.com/wiki/Damage" class="mw-redirect" title="Damage">damage</a></li></ul>',
            description: 'Generates a magical seal that explodes in a burst of electrical energy when an enemy comes into contact with it, inflicting Shock damage.',
        },
        {
            level: '5',
            link: 'https://pillarsofeternity.fandom.com/wiki/Watchful_Presence',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/8/8c/Watchful_presence_icon.png',
            name: 'Watchful Presence',
            speed: 'Average',
            range: '5m',
            area: '5.0m Radius',
            duration: '',
            effects: '<ul><li>Friendly AoE: +35 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a> when <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" class="mw-redirect" title="Endurance">Endurance</a> below 20%</li></ul>',
            description: 'Blesses allies with the aid of a sympathetic soul, releasing a healing effect when their Endurance is low.',
        },
        {
            level: '7',
            link: 'https://pillarsofeternity.fandom.com/wiki/Barring_Death%27s_Door',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/6/61/Barring_deaths_door_icon.png',
            name: 'Barring Death\'s Door',
            speed: 'Fast',
            range: '5m',
            area: '',
            duration: '20.0 seconds',
            effects: '<ul><li>Friendly Target: Prevent <a href="https://pillarsofeternity.fandom.com/wiki/Death" class="mw-redirect" title="Death">Death</a></li></ul>',
            description: 'Prevents a severely wounded character\'s Health from reaching 0 when it would result in the death of the character. The character can still be knocked out through Endurance loss.',
        },
        {
            level: '7',
            link: 'https://pillarsofeternity.fandom.com/wiki/Devotions_for_the_Faithful',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/8/82/Devotions_for_the_faithful_icon.png',
            name: 'Devotions for the Faithful',
            speed: 'Average',
            range: '5m',
            area: '2.5m Radius',
            duration: '30.0 seconds',
            effects: '<ul><li>Friendly AoE: +4 <a href="https://pillarsofeternity.fandom.com/wiki/Might" title="Might">Might</a>, +20 <a href="https://pillarsofeternity.fandom.com/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a></li><li>Foe AoE: -10 <a href="https://pillarsofeternity.fandom.com/wiki/Might" title="Might">Might</a>, -20 <a href="https://pillarsofeternity.fandom.com/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a></li></ul>',
            description: 'Invokes the benediction of the priest\'s god, imbuing allies in the area of effect with Accuracy and Might bonuses while enemies receive penalties to the same.',
        },
        {
            level: '7',
            link: 'https://pillarsofeternity.fandom.com/wiki/Litany_Against_Minor_Afflictions',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/c/cc/Litany_against_minor_afflictions_icon.png',
            name: 'Litany Against Minor Afflictions',
            speed: 'Fast',
            range: '5m',
            area: '',
            duration: '20.0 seconds',
            effects: '<ul><li>Friendly Target: Immunity: <a href="https://pillarsofeternity.fandom.com/wiki/Blinded" class="mw-redirect" title="Blinded">Blinded</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Hobbled" class="mw-redirect" title="Hobbled">Hobbled</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Frightened" class="mw-redirect" title="Frightened">Frightened</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Distracted" class="mw-redirect" title="Distracted">Distracted</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Dazed" class="mw-redirect" title="Dazed">Dazed</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Confused" class="mw-redirect" title="Confused">Confused</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Prone" class="mw-redirect" title="Prone">Prone</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Stuck" class="mw-redirect" title="Stuck">Stuck</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Sickened" class="mw-redirect" title="Sickened">Sickened</a></li></ul>',
            description: 'Grants a single ally temporary immunity to the Blinded, Confused, Dazed, Distracted, Frightened, Hobbled, Prone, Sickened, and Stuck afflictions.',
        },
        {
            level: '7',
            link: 'https://pillarsofeternity.fandom.com/wiki/Prayer_Against_Bewilderment',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/e/ed/Prayer_against_bewilderment_icon.png',
            name: 'Prayer Against Bewilderment',
            speed: 'Fast',
            range: '5m',
            area: '3.0m Radius',
            duration: '20.0 seconds',
            effects: '<ul><li>Friendly AoE: Immunity: <a href="https://pillarsofeternity.fandom.com/wiki/Confused" class="mw-redirect" title="Confused">Confused</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Dazed" class="mw-redirect" title="Dazed">Dazed</a></li></ul>',
            description: 'Bestows alacrity upon the minds of allies in the area of effect, granting immunity to the Confused and Dazed afflictions.',
        },
        {
            level: '7',
            link: 'https://pillarsofeternity.fandom.com/wiki/Restore_Major_Endurance',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/4/46/Restore_major_endurance_icon.png',
            name: 'Restore Major Endurance',
            speed: 'Fast',
            range: '5m',
            area: '1.5m Radius',
            duration: '',
            effects: '<ul><li>Friendly AoE: +38 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a></li></ul>',
            description: 'Shares a generous portion of the caster\'s divine strength, restoring a significant amount of Endurance to all allies in the area of effect.',
        },
        {
            level: '7',
            link: 'https://pillarsofeternity.fandom.com/wiki/Searing_Seal',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/e/eb/Searing_seal_icon.png',
            name: 'Searing Seal',
            speed: 'Average',
            range: '10m',
            area: '2.5m Radius Hazard',
            duration: '600.0 seconds',
            effects: '<ul><li>20-35 <a href="https://pillarsofeternity.fandom.com/wiki/Burn" title="Burn"><img alt="Burn" src="https://static.wikia.nocookie.net/eternitywiki/images/a/aa/Burn_icon.png" decoding="async" width="18" height="18" /></a> damage (<a href="https://pillarsofeternity.fandom.com/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a> vs <a href="https://pillarsofeternity.fandom.com/wiki/Will" title="Will"><img alt="Will" src="https://static.wikia.nocookie.net/eternitywiki/images/9/96/Will_icon.png" decoding="async" width="18" height="18" /></a>)</li><li>If successful: <a href="https://pillarsofeternity.fandom.com/wiki/Blinded" class="mw-redirect" title="Blinded">Blinded</a> for 15 seconds (<a href="https://pillarsofeternity.fandom.com/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a> vs <a href="https://pillarsofeternity.fandom.com/wiki/Will" title="Will"><img alt="Will" src="https://static.wikia.nocookie.net/eternitywiki/images/9/96/Will_icon.png" decoding="async" width="18" height="18" /></a>)</li></ul>',
            description: 'Places a magical seal on the floor that bursts into flame when an enemy comes into contact with it, Blinding them and inflicting Burn damage.',
        },
        {
            level: '7',
            link: 'https://pillarsofeternity.fandom.com/wiki/Shining_Beacon',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/9/9d/Shining_beacon_icon.png',
            name: 'Shining Beacon',
            speed: 'Average',
            range: '5m',
            area: '2.5m Radius',
            duration: '9.0 seconds',
            effects: '<ul><li>Foe AoE: -10 All <a href="https://pillarsofeternity.fandom.com/wiki/Defense" title="Defenses"><img alt="Defenses" src="https://static.wikia.nocookie.net/eternitywiki/images/a/af/Defenses_icon.png" decoding="async" width="16" height="16" /></a></li><li>Foe AoE: 80 <a href="https://pillarsofeternity.fandom.com/wiki/Burn" title="Burn"><img alt="Burn" src="https://static.wikia.nocookie.net/eternitywiki/images/a/aa/Burn_icon.png" decoding="async" width="18" height="18" /></a> damage over time</li></ul>',
            description: 'Conjures an intensely luminous beacon of light, causing enemies in the area of effect to take a penalty to all defenses and accrue Burn damage over time.',
        },
        {
            level: '7',
            link: 'https://pillarsofeternity.fandom.com/wiki/Triumph_of_the_Crusaders',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/b/bd/Triumph_of_the_crusaders_icon.png',
            name: 'Triumph of the Crusaders',
            speed: 'Average',
            range: '10m',
            area: '1.25m Radius',
            duration: '',
            effects: '<ul><li>Friendly AoE: +200 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a> per kill</li></ul>',
            description: 'Imparts to allies the fervor of righteousness in battle. When any ally in the area of effect delivers a killing blow, he or she regains Endurance.',
        },
        {
            level: '9',
            link: 'https://pillarsofeternity.fandom.com/wiki/Champion%27s_Boon',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/2/2b/Champions_boon_icon.png',
            name: 'Champion\'s Boon',
            speed: 'Average',
            range: '',
            area: '',
            duration: '30.0 seconds',
            effects: '<ul><li>Friendly Target: +10 <a href="https://pillarsofeternity.fandom.com/wiki/Might" title="Might">Might</a></li><li>Friendly Target: +10 <a href="https://pillarsofeternity.fandom.com/wiki/Perception" title="Perception">Perception</a></li><li>Friendly Target: +5 <a href="https://pillarsofeternity.fandom.com/wiki/Damage_Reduction" title="Damage Reduction (DR)"><img alt="Damage Reduction (DR)" src="https://static.wikia.nocookie.net/eternitywiki/images/2/29/Damage_reduction_icon.png" decoding="async" width="16" height="16" /></a></li></ul>',
            description: 'Grants a divine favor to an ally, imbuing him or her with a bonus to Might, Perception and all Damage Reductions.',
        },
        {
            level: '9',
            link: 'https://pillarsofeternity.fandom.com/wiki/Pillar_of_Holy_Fire',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/4/46/Pillar_of_holy_fire_icon.png',
            name: 'Pillar of Holy Fire',
            speed: 'Average',
            range: '10m',
            area: '1.25m Radius',
            duration: '',
            effects: '<ul><li>AoE: 50-60 <a href="https://pillarsofeternity.fandom.com/wiki/Burn" title="Burn"><img alt="Burn" src="https://static.wikia.nocookie.net/eternitywiki/images/a/aa/Burn_icon.png" decoding="async" width="18" height="18" /></a> damage</li></ul>',
            description: 'Summons a flaming pillar of righteous anger, Burning everyone in the area of effect.',
        },
        {
            level: '9',
            link: 'https://pillarsofeternity.fandom.com/wiki/Prayer_Against_Imprisonment',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/f/f2/Prayer_against_imprisonment_icon.png',
            name: 'Prayer Against Imprisonment',
            speed: 'Fast',
            range: '5m',
            area: '3.0m Radius',
            duration: '20.0 seconds',
            effects: '<ul><li>Friendly AoE: Immunity: <a href="https://pillarsofeternity.fandom.com/wiki/Paralyzed" class="mw-redirect" title="Paralyzed">Paralyzed</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Petrified" class="mw-redirect" title="Petrified">Petrified</a></li></ul>',
            description: 'Instills a spirit of liberation in allies in the area of effect, granting immunity to the Paralyzed and Petrified afflictions.',
        },
        {
            level: '9',
            link: 'https://pillarsofeternity.fandom.com/wiki/Restore_Critical_Endurance',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/7/79/Restore_critical_endurance_icon.png',
            name: 'Restore Critical Endurance',
            speed: 'Fast',
            range: '5m',
            area: '1.5m Radius',
            duration: '',
            effects: '<ul><li>Friendly AoE: +55 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a></li></ul>',
            description: 'Shares a substantial portion of the caster\'s divine strength, restoring a large amount of Endurance to all allies in the area of effect.',
        },
        {
            level: '9',
            link: 'https://pillarsofeternity.fandom.com/wiki/Revive_the_Fallen',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/7/73/Revive_the_fallen_icon.png',
            name: 'Revive the Fallen',
            speed: 'Average',
            range: '5m',
            area: '1.25m Radius',
            duration: '',
            effects: '<ul><li>Friendly AoE: Revive with 50 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a></li></ul>',
            description: 'Grants fallen friends a second chance, reviving unconscious allies in the area of effect and restoring a small amount of their Endurance.',
        },
        {
            level: '9',
            link: 'https://pillarsofeternity.fandom.com/wiki/Salvation_of_Time',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/0/0a/Salvation_of_time_icon.png',
            name: 'Salvation of Time',
            speed: 'Average',
            range: '10m',
            area: '2.5m Radius',
            duration: '',
            effects: '<ul><li>Friendly AoE: +10 seconds duration of active beneficial effects</li></ul>',
            description: 'Beseeches the gods for more time, extending the duration of all beneficial effects on allies in the area of effect.',
        },
        {
            level: '9',
            link: 'https://pillarsofeternity.fandom.com/wiki/Shields_for_the_Faithful',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/d/d9/Shields_for_the_faithful_icon.png',
            name: 'Shields for the Faithful',
            speed: 'Average',
            range: '10m',
            area: '1.75m Radius',
            duration: '30.0 seconds',
            effects: '<ul><li>Friendly AoE: +25 <a href="https://pillarsofeternity.fandom.com/wiki/Deflection" title="Deflection"><img alt="Deflection" src="https://static.wikia.nocookie.net/eternitywiki/images/3/3e/Deflection_icon.png" decoding="async" width="18" height="18" /></a></li></ul>',
            description: 'Conjures a powerful holy shield, granting a Deflection bonus to all allies in the area of effect.',
        },
        {
            level: '11',
            link: 'https://pillarsofeternity.fandom.com/wiki/Cleansing_Flame',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/d/dc/Cleansing_flame_icon.png',
            name: 'Cleansing Flame',
            speed: 'Average',
            range: '10m + 3m Jump',
            area: 'Foe Target + 2 Jump Targets',
            duration: '5.0 seconds',
            effects: '<ul><li>Foe Target: 80 <a href="https://pillarsofeternity.fandom.com/wiki/Burn" title="Burn"><img alt="Burn" src="https://static.wikia.nocookie.net/eternitywiki/images/a/aa/Burn_icon.png" decoding="async" width="18" height="18" /></a> damage over time</li><li>Foe Target: -5 seconds duration of active beneficial effects</li><li>Foe Target: +100% Damage Over Time tick rate</li><li>Foe Jump Targets (x2): Applies same effects as Foe Target</li></ul>',
            description: 'The priest hurls a ball of holy fire at the enemy that purges its protections and speeds its doom. Does continuous Burn damage for five seconds and accelerates the timer for all beneficial effects on the target (except heals), as well as those of any continuous damage effects. Leaps to up to two add',
        },
        {
            level: '11',
            link: 'https://pillarsofeternity.fandom.com/wiki/Crowns_for_the_Faithful',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/0/0a/Crowns_for_the_faithful_icon.png',
            name: 'Crowns for the Faithful',
            speed: 'Average',
            range: '10m',
            area: '1.25m Radius',
            duration: '30.0 seconds',
            effects: '<ul><li>Friendly AoE: +6 <a href="https://pillarsofeternity.fandom.com/wiki/Perception" title="Perception">Perception</a></li><li>Friendly AoE: +6 <a href="https://pillarsofeternity.fandom.com/wiki/Intellect" title="Intellect">Intellect</a></li><li>Friendly AoE: +25 <a href="https://pillarsofeternity.fandom.com/wiki/Resolve" title="Resolve">Resolve</a></li></ul>',
            description: 'Crowns allies in the glory of the priest\'s god, imbuing all allies in the area of effect with bonuses to Perception, Intellect, and Resolve.',
        },
        {
            level: '11',
            link: 'https://pillarsofeternity.fandom.com/wiki/Litany_Against_Major_Afflictions',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/4/4b/Litany_against_major_afflictions_icon.png',
            name: 'Litany Against Major Afflictions',
            speed: 'Fast',
            range: '5m',
            area: '',
            duration: '20.0 seconds',
            effects: '<ul><li>Friendly Target: Immunity: <a href="https://pillarsofeternity.fandom.com/wiki/Charmed" class="mw-redirect" title="Charmed">Charmed</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Terrified" class="mw-redirect" title="Terrified">Terrified</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Stunned" class="mw-redirect" title="Stunned">Stunned</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Petrified" class="mw-redirect" title="Petrified">Petrified</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Paralyzed" class="mw-redirect" title="Paralyzed">Paralyzed</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Dominated" class="mw-redirect" title="Dominated">Dominated</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Weakened" class="mw-redirect" title="Weakened">Weakened</a></li></ul>',
            description: 'Grants a single ally temporary immunity to the Charmed, Dominated, Paralyzed, Petrified, Stunned, Terrified, and Weakened afflictions.',
        },
        {
            level: '11',
            link: 'https://pillarsofeternity.fandom.com/wiki/Minor_Intercession',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/b/b5/Minor_intercession_icon.png',
            name: 'Minor Intercession',
            speed: 'Fast',
            range: '5m',
            area: '5.0m Radius',
            duration: '',
            effects: '<ul><li>Friendly AoE: +25 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a></li><li>Friendly AoE: -5 seconds duration of active hostile effects</li></ul>',
            description: 'Calls upon the aid of the priest\'s god, restoring Endurance and reducing durations of negative effects for all allies in the area of effect.',
        },
        {
            level: '11',
            link: 'https://pillarsofeternity.fandom.com/wiki/Prayer_Against_Treachery',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/2/21/Prayer_against_treachery_icon.png',
            name: 'Prayer Against Treachery',
            speed: 'Fast',
            range: '5m',
            area: '3.0m Radius',
            duration: '20.0 seconds',
            effects: '<ul><li>Friendly AoE: Immunity: <a href="https://pillarsofeternity.fandom.com/wiki/Charmed" class="mw-redirect" title="Charmed">Charmed</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Dominated" class="mw-redirect" title="Dominated">Dominated</a></li></ul>',
            description: 'Galvanizes the devotion of the party, granting immunity to the Charmed and Dominated afflictions.',
        },
        {
            level: '11',
            link: 'https://pillarsofeternity.fandom.com/wiki/Spark_the_Souls_of_the_Righteous',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/1/16/Spark_the_souls_of_the_righteous_icon.png',
            name: 'Spark the Souls of the Righteous',
            speed: 'Average',
            range: '2.5m',
            area: '2.5m Radius',
            duration: '30.0 seconds',
            effects: '<ul><li>Allied AoE: Aura dealing <a href="https://pillarsofeternity.fandom.com/wiki/Shock" title="Shock"><img alt="Shock" src="https://static.wikia.nocookie.net/eternitywiki/images/8/89/Shock_icon.png" decoding="async" width="18" height="18" /></a> damage to enemies</li></ul>',
            description: 'Ignites a powerful zeal within allies that manifests in an aura that Shocks any enemies near them.',
        },
        {
            level: '13',
            link: 'https://pillarsofeternity.fandom.com/wiki/Minor_Avatar',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/b/b8/Minor_avatar_icon.png',
            name: 'Minor Avatar',
            speed: 'Average',
            range: '',
            area: '',
            duration: '30.0 seconds',
            effects: '<ul><li>+20% <a href="https://pillarsofeternity.fandom.com/wiki/Damage" title="Damage"><img alt="Damage" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e2/Damage_icon.png" decoding="async" width="18" height="18" /></a></li><li>+8 <a href="https://pillarsofeternity.fandom.com/wiki/Might" title="Might">Might</a></li><li>+8 <a href="https://pillarsofeternity.fandom.com/wiki/Dexterity" title="Dexterity">Dexterity</a></li><li>+8 <a href="https://pillarsofeternity.fandom.com/wiki/Constitution" title="Constitution">Constitution</a></li><li>+8 <a href="https://pillarsofeternity.fandom.com/wiki/Perception" title="Perception">Perception</a></li><li>+8 <a href="https://pillarsofeternity.fandom.com/wiki/Resolve" title="Resolve">Resolve</a></li><li>+8 <a href="https://pillarsofeternity.fandom.com/wiki/Intellect" title="Intellect">Intellect</a></li><li>+40 Max <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a></li></ul>',
            description: 'The priest gains a supernatural glow as he or she is infused with power. As a minor avatar of their deity, the priest gains bonuses in all Attributes, Endurance, Health, and weapon damage.',
        },
        {
            level: '13',
            link: 'https://pillarsofeternity.fandom.com/wiki/Resurrection',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/b/ba/Resurrection_icon.png',
            name: 'Resurrection',
            speed: 'Average',
            range: '5m',
            area: 'Friendly Target + 1.5m Radius',
            duration: '20.0 seconds',
            effects: '<ul><li>Friendly Target: Revive with 125 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a></li><li>Friendly Target: Prevent <a href="https://pillarsofeternity.fandom.com/wiki/Death" class="mw-redirect" title="Death">Death</a> for 20 seconds</li><li>Friendly AoE: +75 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a></li></ul>',
            description: 'A single ally is revived and healed. They receive the effects of Barring Death\'s Door and nearby allies are healed.',
        },
        {
            level: '13',
            link: 'https://pillarsofeternity.fandom.com/wiki/Storm_of_Holy_Fire',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/9/92/Storm_of_holy_fire_icon.png',
            name: 'Storm of Holy Fire',
            speed: 'Slow',
            range: '15m',
            area: '5.0m Radius',
            duration: '9.0 seconds',
            effects: '<ul><li>AoE: 24-30 <a href="https://pillarsofeternity.fandom.com/wiki/Burn" title="Burn"><img alt="Burn" src="https://static.wikia.nocookie.net/eternitywiki/images/a/aa/Burn_icon.png" decoding="async" width="18" height="18" /></a> damage</li></ul>',
            description: 'A terrible rain of fire falls in the area of effect, repeatedly inflicting Burn damage on all in the area of effect.',
        },
        {
            level: '15',
            link: 'https://pillarsofeternity.fandom.com/wiki/Hand_of_Weal_and_Woe',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/4/4f/Hand_of_weal_and_woe_icon.png',
            name: 'Hand of Weal and Woe',
            speed: 'Fast',
            range: '5m',
            area: '',
            duration: '10.0 seconds',
            effects: '<ul><li>Foe Target: 25 <a href="https://pillarsofeternity.fandom.com/wiki/Burn" title="Burn"><img alt="Burn" src="https://static.wikia.nocookie.net/eternitywiki/images/a/aa/Burn_icon.png" decoding="async" width="18" height="18" /></a> damage per second</li><li>Foe Beam: 25 <a href="https://pillarsofeternity.fandom.com/wiki/Burn" title="Burn"><img alt="Burn" src="https://static.wikia.nocookie.net/eternitywiki/images/a/aa/Burn_icon.png" decoding="async" width="18" height="18" /></a> damage per second</li><li>Friendly Target: +25 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a> per second</li><li>Friendly Beam: +25 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a> per second</li></ul>',
            description: 'The priest calls forth a beam of light that heals allies and burns enemies caught in the ray.',
        },
        {
            level: '15',
            link: 'https://pillarsofeternity.fandom.com/wiki/Symbol_of_Berath',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/e/e2/Symbol_of_deity_icon.png',
            name: 'Symbol of Berath',
            deity: 'Berath',
            speed: 'Average',
            range: '3m',
            area: '2.5m Radius',
            duration: '20.0 seconds',
            effects: '<ul><li>Foe AoE: 15-25 <a href="https://pillarsofeternity.fandom.com/wiki/Corrode" title="Corrode"><img alt="Corrode" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Corrode_icon.png" decoding="async" width="18" height="18" /></a> damage</li><li>Foe AoE: If successful: <a href="https://pillarsofeternity.fandom.com/wiki/Weakened" class="mw-redirect" title="Weakened">Weakened</a> for 3 seconds</li></ul>',
            description: 'Emblazons the ground with the symbol of Berath, periodically causing Corrode damage to enemies and leaving them Weakened.',
        },
        {
            level: '15',
            link: 'https://pillarsofeternity.fandom.com/wiki/Symbol_of_Eothas',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/e/e2/Symbol_of_deity_icon.png',
            name: 'Symbol of Eothas',
            deity: 'Eothas',
            speed: 'Average',
            range: '3m',
            area: '2.5m Radius',
            duration: '20.0 seconds',
            effects: '<ul><li>Foe AoE: 15-25 <a href="https://pillarsofeternity.fandom.com/wiki/Burn" title="Burn"><img alt="Burn" src="https://static.wikia.nocookie.net/eternitywiki/images/a/aa/Burn_icon.png" decoding="async" width="18" height="18" /></a> damage</li><li>Friendly AoE: +20 All <a href="https://pillarsofeternity.fandom.com/wiki/Defense" title="Defenses"><img alt="Defenses" src="https://static.wikia.nocookie.net/eternitywiki/images/a/af/Defenses_icon.png" decoding="async" width="16" height="16" /></a> for 3 seconds</li></ul>',
            description: 'Emblazons the ground with the symbol of Eothas, periodically causing Burn damage to enemies in the area and granting defensive bonuses to allies.',
        },
        {
            level: '15',
            link: 'https://pillarsofeternity.fandom.com/wiki/Symbol_of_Magran',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/e/e2/Symbol_of_deity_icon.png',
            name: 'Symbol of Magran',
            deity: 'Magran',
            speed: 'Average',
            range: '3m',
            area: '2.5m Radius',
            duration: '20.0 seconds',
            effects: '<ul><li>Foe AoE: 15-25 <a href="https://pillarsofeternity.fandom.com/wiki/Burn" title="Burn"><img alt="Burn" src="https://static.wikia.nocookie.net/eternitywiki/images/a/aa/Burn_icon.png" decoding="async" width="18" height="18" /></a> damage</li><li>Foe AoE: If successful: <a href="https://pillarsofeternity.fandom.com/wiki/Blinded" class="mw-redirect" title="Blinded">Blinded</a> for 3 seconds</li></ul>',
            description: 'Emblazons the ground with the symbol of Magran, periodically causing Burn damage to enemies in the area and leaving them Blinded.',
        },
        {
            level: '15',
            link: 'https://pillarsofeternity.fandom.com/wiki/Symbol_of_Skaen',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/e/e2/Symbol_of_deity_icon.png',
            name: 'Symbol of Skaen',
            deity: 'Skaen',
            speed: 'Average',
            range: '3m',
            area: '2.5m Radius',
            duration: '20.0 seconds',
            effects: '<ul><li>Foe AoE: 15-25 <a href="https://pillarsofeternity.fandom.com/wiki/Pierce" title="Pierce"><img alt="Pierce" src="https://static.wikia.nocookie.net/eternitywiki/images/5/52/Pierce_icon.png" decoding="async" width="18" height="18" /></a> damage (<a href="https://pillarsofeternity.fandom.com/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a> vs <a href="https://pillarsofeternity.fandom.com/wiki/Deflection" title="Deflection"><img alt="Deflection" src="https://static.wikia.nocookie.net/eternitywiki/images/3/3e/Deflection_icon.png" decoding="async" width="18" height="18" /></a>)</li><li>Foe AoE: If successful: <a href="https://pillarsofeternity.fandom.com/wiki/Hobbled" class="mw-redirect" title="Hobbled">Hobbled</a> for 3 seconds (<a href="https://pillarsofeternity.fandom.com/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a> vs&#160;<a href="https://pillarsofeternity.fandom.com/wiki/Reflex" title="Reflex"><img alt="Reflex" src="https://static.wikia.nocookie.net/eternitywiki/images/8/80/Reflex_icon.png" decoding="async" width="18" height="18" /></a>)</li></ul>',
            description: 'Emblazons the ground with the symbol of Skaen, periodically causing Pierce damage to enemies in the area and leaving them Hobbled.',
        },
        {
            level: '15',
            link: 'https://pillarsofeternity.fandom.com/wiki/Symbol_of_Wael',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/e/e2/Symbol_of_deity_icon.png',
            name: 'Symbol of Wael',
            deity: 'Wael',
            speed: 'Average',
            range: '3m',
            area: '2.5m Radius',
            duration: '20.0 seconds',
            effects: '<ul><li>Foe AoE: 15-25 <a href="https://pillarsofeternity.fandom.com/wiki/Freeze" title="Freeze"><img alt="Freeze" src="https://static.wikia.nocookie.net/eternitywiki/images/9/95/Freeze_icon.png" decoding="async" width="18" height="18" /></a> damage</li><li>Friendly AoE: +30 <a href="https://pillarsofeternity.fandom.com/wiki/Defense" title="Defenses"><img alt="Defenses" src="https://static.wikia.nocookie.net/eternitywiki/images/a/af/Defenses_icon.png" decoding="async" width="16" height="16" /></a> against <a href="https://pillarsofeternity.fandom.com/wiki/Charmed" class="mw-redirect" title="Charmed">Charmed</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Confused" class="mw-redirect" title="Confused">Confused</a>, <a href="https://pillarsofeternity.fandom.com/wiki/Dominated" class="mw-redirect" title="Dominated">Dominated</a> attacks for 3 seconds</li></ul>',
            description: 'Emblazons the ground with the symbol of Wael, periodically causing Freeze damage to enemies in the area and granting Confused, Charmed, and Dominated resistance to allies.',
        },
        {
            level: '15',
            link: 'https://pillarsofeternity.fandom.com/wiki/Watchful_Guardian',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/7/7a/Watchful_guardian_icon.png',
            name: 'Watchful Guardian',
            speed: 'Average',
            range: '5m',
            area: '5.0m Radius',
            duration: '',
            effects: '<ul><li>Friendly AoE: Revive with 75 <a href="https://pillarsofeternity.fandom.com/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a> on <a href="https://pillarsofeternity.fandom.com/wiki/Unconscious" title="Unconscious">Unconscious</a></li></ul>',
            description: 'The priest\'s faith becomes a wellspring of indomitability for his or her allies. When an affected ally is knocked unconscious in battle, he or she will immediately be revived and have some Endurance healed.',
        },
    ],
    deities: Object.values(deity),
    talents: [
        {
            name: 'Interdiction',
            link: 'https://pillarsofeternity.fandom.com/wiki/Interdiction',
            imageLink: priestPassiveImageLink,
            effects: '<ul><li>Foe AoE: <a href="/wiki/Dazed" class="mw-redirect" title="Dazed">Dazed</a></li></ul>'
        },
        {
            name: 'Empowered Interdiction',
            link: 'https://pillarsofeternity.fandom.com/wiki/Empowered_Interdiction',
            imageLink: priestPassiveImageLink,
            description: 'Increasing the Accuracy of priest\'s Interdiction ability.',
            requiredTalent: 'Interdiction'
        },
        {
            name: 'Untroubled Faith',
            link: 'https://pillarsofeternity.fandom.com/wiki/Untroubled_Faith_(Priest)',
            imageLink: priestPassiveImageLink,
            effects: '<ul><li>Negates <a href="/wiki/Disposition" title="Disposition">disposition</a> penalties to <a href="/wiki/Holy_Radiance" title="Holy Radiance">Holy Radiance</a></li></ul>'
        },
        {
            name: 'Painful Interdiction',
            link: 'https://pillarsofeternity.fandom.com/wiki/Painful_Interdiction',
            imageLink: priestPassiveImageLink,
            description: 'Adds a painful Weakening affliction to Interdiction.',
            requiredTalent: 'Interdiction'
        },
        {
            name: 'Brilliant Radiance',
            link: 'https://pillarsofeternity.fandom.com/wiki/Brilliant_Radiance',
            imageLink: priestPassiveImageLink,
            description: 'Enemies take Burn damage from the priest\'s Holy Radiance (vessels take increased Burn damage).'
        },
        {
            name: 'Inspiring Radiance',
            link: 'https://pillarsofeternity.fandom.com/wiki/Inspiring_Radiance',
            imageLink: priestPassiveImageLink,
            description: 'Allies gain an Accuracy bonus from the priest\'s Holy Radiance.'
        },
        {
            name: 'Aggrandizing Radiance',
            link: 'https://pillarsofeternity.fandom.com/wiki/Aggrandizing_Radiance',
            imageLink: priestPassiveImageLink,
            description: 'Everyone receives less healing from the priest\'s Holy Radiance, but the priest gains a bonus to all Attributes and Movement.'
        },
        {
            name: 'Bonus 1st Level Spell',
            description: 'Gain an extra spell cast of level 1 spells.',
            link: 'https://pillarsofeternity.fandom.com/wiki/Bonus_1st_Level_Spell',
            imageLink: commonPassiveImageLink
        },
        {
            name: 'Bonus 2nd Level Spell',
            description: 'Gain an extra spell cast of level 2 spells.',
            link: 'https://pillarsofeternity.fandom.com/wiki/Bonus_2nd_Level_Spell',
            imageLink: commonPassiveImageLink
        },
        {
            name: 'Bonus 3rd Level Spell',
            description: 'Gain an extra spell cast of level 3 spells.',
            link: 'https://pillarsofeternity.fandom.com/wiki/Bonus_3rd_Level_Spell',
            imageLink: commonPassiveImageLink
        },
        {
            name: 'Bonus 4th Level Spell',
            description: 'Gain an extra spell cast of level 4 spells.',
            link: 'https://pillarsofeternity.fandom.com/wiki/Bonus_4th_Level_Spell',
            imageLink: commonPassiveImageLink
        },
        {
            name: 'The Pallid Hand',
            link: 'https://pillarsofeternity.fandom.com/wiki/The_Pallid_Hand',
            imageLink: priestPassiveImageLink,
            description: 'The faithful of Berath gain an Accuracy bonus with Mace and Great Sword and can cast a special version of Concelhaut\'s Corrosive Siphon.',
            deity: deity.berath
        },
        {
            name: 'Inspired Flame',
            link: 'https://pillarsofeternity.fandom.com/wiki/Inspired_Flame',
            imageLink: priestPassiveImageLink,
            description: 'The faithful of Magran gain an Accuracy bonus with Sword and Arquebus and can cast a special version of Burst of Summer Flame.',
            deity: deity.magran
        },
        {
            name: 'Hope Eternal',
            link: 'https://pillarsofeternity.fandom.com/wiki/Hope_Eternal',
            imageLink: priestPassiveImageLink,
            description: 'The faithful of Eothas gain an Accuracy bonus with Flail and Morning Star and can cast a healing spell that shortens Frightened and Terrified durations.',
            deity: deity.eothas
        },
        {
            name: 'Prey on the Weak',
            link: 'https://pillarsofeternity.fandom.com/wiki/Prey_on_the_Weak',
            imageLink: priestPassiveImageLink,
            description: 'The faithful of Skaen gain an Accuracy bonus with Stiletto and Club and gain a lesser version of the rogue\'s Sneak Attack ability.',
            deity: deity.skaen
        },
        {
            name: 'Incomprehensible Revelation',
            link: 'https://pillarsofeternity.fandom.com/wiki/Incomprehensible_Revelation',
            imageLink: priestPassiveImageLink,
            description: 'The faithful of Wael gain an Accuracy bonus with Quarterstaff and Rod and can cast a special version of Arkemyr\'s Dazzling Lights.',
            deity: deity.wael
        }
    ]
};
